export default __webpack_public_path__ + "static/media/Pet Grey Lotus.5a0ac340.jpg";